<template>
    <!-- 票券管理－新增编辑详情页 -->
    <content-view>
        <div class="add-ticket">
            <div class="add-ticket-tab">
                <a-tabs type="card" :activeKey="activeKey" :animated="false" @change="changeTab">
                    <a-tab-pane tab="基本信息" :key="1"></a-tab-pane>
                    <a-tab-pane tab="销售信息" :key="2"></a-tab-pane>
                    <a-tab-pane tab="预约信息" :key="3"></a-tab-pane>
                    <a-tab-pane tab="使用信息" :key="4"></a-tab-pane>
                    <a-tab-pane tab="图文描述" :key="5"></a-tab-pane>
                </a-tabs>
            </div>
            <a-spin :spinning="detailLoading">
                <a-form :form="form">
                    <a-form-item class="no-margin_bottom">
                        <a-input :disabled="isDisable" type="hidden" v-decorator="['ticketTemplateId']" />
                    </a-form-item>
                    <!-- 基本信息 -->
                    <div class="add-ticket-block">
                        <a-card :bordered="false" title="基本信息">
                            <a-form-item v-if="isDisable || isEdit" label="票券id" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                {{ticketTemplateId}}
                            </a-form-item>
                            <a-form-item label="票券展示名称" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input :disabled="isDisable" v-decorator="['showName', {rules: [{required: true, message: '请输入'}, {max: 15, message: '15字以内'}]}]" placeholder="请输入，（15字以内）" />
                                <span>请勿使用【】符号，请使用「」符号代替【】符号</span>
                            </a-form-item>
                            <a-form-item label="票券内部标识" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input :disabled="isEdit || isDisable" v-decorator="['name', {rules: [{required: true, message: '请输入'}, {max: 50, message: '50字以内'}]}]" placeholder="请输入，（50字以内）" />
                            </a-form-item>
                            <a-form-item v-show="!isDisable && !isEdit" label="票券总库存" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isEdit || isDisable" @change="commonChange($event, 'stockTypeState', ['stockNum'])" v-decorator="['stockTypeState', {initialValue: 0, rules: [{required: true, message: '请输入'}]}]">
                                    <a-radio :value="0">不限量</a-radio>
                                    <a-radio :value="1">限制总库存数</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item v-show="!isDisable && !isEdit" label="总库存数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isEdit || isDisable || !Boolean(stockTypeState)" style="width: 100%;" v-decorator="['stockNum', {rules: [{required: Boolean(stockTypeState), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数" />
                            </a-form-item>
                            <a-form-item label="票券类型" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isEdit || isDisable" @change="typeChange" v-decorator="['type', {initialValue: 2, rules: [{required: true, message: '请输入'}]}]">
                                    <a-radio :value="1">期限卡</a-radio>
                                    <a-radio :value="2">次卡</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="使用总次数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number v-if="useNumDisabled" style="width: 100%;" :disabled="isEdit || isDisable || useNumDisabled" v-decorator="['useNum', {rules: [{required: true, message: '请输入'}]}]" placeholder="请输入" />
                                <a-input-number :max="999999999" v-else style="width: 100%;" :disabled="isEdit || isDisable || useNumDisabled" v-decorator="['useNum', {rules: [{required: true, message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数" />
                            </a-form-item>
                            <a-form-item label="票券有效期" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="validTimeSetModeChange" v-decorator="['validTimeSetMode', {initialValue: 2, rules: [{required: true, message: '请输入'}]}]">
                                    <a-radio :value="1">指定有效天数</a-radio>
                                    <a-radio :value="2">指定有效日期</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item :label="`${validTimeSetMode === 1 ? '有效天数' : '有效日期'}`" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable" v-if="validTimeSetMode === 1" style="width: 100%;" v-decorator="['validTimeSetParam', {rules: [{required: true, message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数" />
                                <!-- ~ 分割 -->
                                <a-range-picker :disabled="isDisable" v-else style="width: 100%;" v-decorator="['validTimeSetParam', {rules: [{required: true, message: '请选择'}]}]" />
                            </a-form-item>
                            <div ref="useShopSet"></div>
                            <a-row>
                                <a-col span="4" class="text-right">
                                    <a-form-item :colon="false" required label="适用门店"></a-form-item>
                                </a-col>
                                <a-col span="10">
                                    <a-button v-if="!isDisable" type="primary" @click="openSelectedShop">新增门店</a-button>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col :span="22" :offset="1">
                                    <a-table bordered :columns="columns" :pagination="false" :dataSource="useShopList" :rowKey="item => item.shopName">
                                        <template slot="stockCategory" slot-scope="key, row, index">
                                            <a-form-item class="no-margin_bottom">
                                                <a-spin :spinning="row.spinning">
                                                    <a-select
                                                    :disabled="isDisable || !isNeedReserve"
                                                    :options="row.options"
                                                    showSearch
                                                    option-filter-prop="children"
                                                    :filter-option="filterOption"
                                                    style="width: 50%"
                                                    v-decorator="[`stockCategoryId[${index}]`, {initialValue: row.stockCategoryId, rules: [{required: isNeedReserve, message: '请选择'}]}]"
                                                    placeholder="请选择"
                                                    >
                                                    </a-select>
                                                </a-spin>
                                            </a-form-item>
                                            <a-form-item class="no-margin_bottom">
                                                <a-input type="hidden" v-decorator="[`configVosShopId[${index}]`, {initialValue: row.shopId}]" />
                                            </a-form-item>
                                            <a-form-item class="no-margin_bottom">
                                                <a-input type="hidden" v-decorator="[`configVosIds[${index}]`, {initialValue: row.id}]" />
                                            </a-form-item>
                                        </template>
                                        <template slot="actions" slot-scope="key, row, index">
                                            <a v-if="!isDisable" class="text-primary" @click="delUseShopItem(index)">删除</a>
                                            <span v-else class="text-disabled">删除</span>
                                        </template>
                                    </a-table>
                                </a-col>
                            </a-row>
                        </a-card>
                    </div>
                    <!-- 销售信息 -->
                    <div class="add-ticket-block">
                        <a-card :bordered="false" title="销售信息">
                            <a-form-item label="票券售卖价" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || isEdit" style="width: 100%;" v-decorator="['sellShowPrice', {rules: [{required: true, message: '请输入'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '必须是正数有且最多保留2位小数'}]}]" placeholder="必须是正数有且最多保留2位小数" />
                            </a-form-item>
                            <a-form-item label="是否展示原价" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isShowOriginal', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="原价" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || form.getFieldValue('isShowOriginal') == 0" style="width: 100%;" v-decorator="['originalPrice', {rules: [{required: form.getFieldValue('isShowOriginal') == 1, message: '请输入'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '必须是正数有且最多保留2位小数'}]}]" placeholder="必须是正数有且最多保留2位小数" />
                            </a-form-item>
                            <a-form-item label="是否在小程序售卖" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isMiniSell', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="是否在积分商城售卖" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable || isEdit" v-decorator="['isPointSell', {initialValue: 1, rules: [{ required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="是否在第三方售卖" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isThirdSell', {initialValue: 1, rules: [{ required: true, message: '请选择'}]}]" @change="commonChange($event, 'isThirdSell', ['isNeedReserve'])">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="第三方售卖渠道" :label-col="{span: 4}" :wrapper-col="{span: 10}" v-show="form.getFieldValue('isThirdSell')==1" required>
                                <a-checkbox :disabled="isDisable" :indeterminate="ThirdSellIndeterminate" :checked="ThirdSellCheckAll" @change="ThirdSellAllChange">
                                    全选
                                </a-checkbox>
                                <a-checkbox-group :disabled="isDisable" @change="ThirdSellChange" :options="ThirdSellData" v-decorator="['ThirdSell']"></a-checkbox-group>
                            </a-form-item>
                            <a-form-item label="小程序上置于购票界面顶部" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isAppSellPlaceTop', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="小程序适用门店展示" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input :disabled="isDisable" v-decorator="['suitScopeShow', {rules: [{max: 15, message: '15字以内'}]}]" placeholder="请输入，（15字以内）" />
                            </a-form-item>
                            <a-form-item label="购买后是否展示在小程序" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isMyTicketShow', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="是否在门店收银台售卖" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="isCounterSellChange" v-decorator="['isCounterSell', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="退款规则" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isRefundAble', {initialValue: 0, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">支持退款</a-radio>
                                    <a-radio :value="0">不支持退款</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="退款备注说明" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input :disabled="isDisable" v-decorator="['refundExplain', {rules: [{max: 12, message: '12字以内'}]}]" placeholder="12字以内" />
                            </a-form-item>
                            <a-form-item label="购买限制" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'BuyNumLimit', ['BuyNumLimitNum'])" v-decorator="['BuyNumLimit', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">限制</a-radio>
                                    <a-radio :value="0">不限制</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="购买限制张数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(BuyNumLimit)" style="width: 100%;" v-decorator="['BuyNumLimitNum', {rules: [{required: Boolean(BuyNumLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                            </a-form-item>
                            <a-form-item label="持有限制" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'HoldNumLimit', ['HoldNumLimitNum'])" v-decorator="['HoldNumLimit', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">限制</a-radio>
                                    <a-radio :value="0">不限制</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="持有限制张数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(HoldNumLimit)" style="width: 100%;" v-decorator="['HoldNumLimitNum', {rules: [{required: Boolean(HoldNumLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                            </a-form-item>
                            <a-form-item label="每日购买限制" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'DayBuyNumLimit', ['DayBuyNumLimitNum'])" v-decorator="['DayBuyNumLimit', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">限制</a-radio>
                                    <a-radio :value="0">不限制</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="每日购买限制张数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(DayBuyNumLimit)" style="width: 100%;" v-decorator="['DayBuyNumLimitNum', {rules: [{required: Boolean(DayBuyNumLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                            </a-form-item>
                            <a-form-item label="上架时间" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="datePickerChange($event, 'enableState')" v-decorator="['enableState', {initialValue: enableState, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">设置上架时间</a-radio>
                                    <a-radio :value="0">暂不设置</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item :required="false" :colon="false" label=" " :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-date-picker :disabled="isDisable || !Boolean(enableState)" showTime style="width: 350px;" v-decorator="['onShelvesTime', {rules: [{required: Boolean(enableState), message: '请输入'}]}]" placeholder="年-月-日 时:分:秒"/>
                            </a-form-item>
                            <a-form-item label="下架时间" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="datePickerChange($event, 'disableState')" v-decorator="['disableState', {initialValue: disableState, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">设置下架时间</a-radio>
                                    <a-radio :value="0">暂不设置</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item :required="false" :colon="false" label=" " :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-date-picker :disabled="isDisable || !Boolean(disableState)" showTime style="width: 350px;" v-decorator="['offShelvesTime', {rules: [{required: Boolean(disableState), message: '请输入'}]}]" placeholder="年-月-日 时:分:秒"/>
                            </a-form-item>
                            <a-form-item label="不可售卖日期" :label-col="{span: 4}" :wrapper-col="{span: 12}">
                                <div class="flex flex-start">
                                    <a-checkbox :disabled="isDisable" :indeterminate="NoSellWeeksLimitIndeterminate" :checked="NoSellWeeksLimitCheckAll" @change="NoSellWeeksLimitAllChange">
                                        全选
                                    </a-checkbox>
                                    <a-checkbox-group :disabled="isDisable" @change="NoSellWeeksLimitChange" :options="weekData" v-decorator="['NoSellWeeksLimit']"></a-checkbox-group>
                                </div>
                            </a-form-item>
                            <a-row class="mb24">
                                <a-col :span="4"></a-col>
                                <a-col>
                                    <a v-if="!isDisable" class="text-primary" @click="addExcludeDate()">增加排除日期</a>
                                </a-col>
                            </a-row>
                            <template v-for="(item, index) in excludeDateList">
                                <a-row :key="'excludeDate' + item.key">
                                    <a-col span="14">
                                        <a-form-item label="排除日期范围" :label-col="{span: 7}" :wrapper-col="{span: 17}">
                                            <a-range-picker :disabled="isDisable" style="width: 100%;" v-decorator="[`NoSellDatesLimit[${index}]`, {initialValue: item.value, rules: [{required: true, message: '请输入'}]}]" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="10">
                                        <a v-if="!isDisable" @click="delExcludeDate(index)" class="text-primary ml16" style="line-height: 32px;">删除</a>
                                    </a-col>
                                </a-row>
                            </template>
                        </a-card>
                    </div>
                    <!-- 预约信息 -->
                    <div class="add-ticket-block">
                        <a-card :bordered="false" title="预约信息">
                            <a-row class="mb24" v-if="form.getFieldValue('isThirdSell') == 1">
                                <a-col span="10" offset="4">
                                    <a-alert type="info" show-icon message="在第三方平台售卖的票券，不支持预约设置"></a-alert>
                                </a-col>
                            </a-row>
                            <a-form-item label="是否需要预约" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable || isNeedReserveDisabled || form.getFieldValue('isThirdSell') == 1" @change="commonChange($event, 'isNeedReserve', ['ReserveAdvanceDaysLimit', 'ReserveAdvanceDaysLimitNum', 'DayReserveNumLimit', 'DayReserveNumLimitNum', 'isCanCancelReserve', 'CancelReserveAdvanceDaysLimit', 'CancelReserveAdvanceDaysLimitNum' ])" v-decorator="['isNeedReserve', {initialValue: form.getFieldValue('isThirdSell') == 1 ? 0 : 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">需要预约</a-radio>
                                    <a-radio :value="0">无需预约</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <div v-show="isNeedReserve">
                                <a-form-item label="预约规则" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-radio-group @change="commonChange($event, 'ReserveAdvanceDaysLimit', ['ReserveAdvanceDaysLimitNum'])" :disabled="isDisable || !Boolean(isNeedReserve)" v-decorator="['ReserveAdvanceDaysLimit', {initialValue: ReserveAdvanceDaysLimit, rules: [{required: Boolean(isNeedReserve), message: '请选择'}]}]">
                                        <a-radio :value="0">当天可约</a-radio>
                                        <a-radio :value="1">提前预约</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                                <a-form-item label="提前天数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-input-number :max="999999999" :disabled="isDisable || !Boolean(isNeedReserve) || !Boolean(ReserveAdvanceDaysLimit)" style="width: 100%;" v-decorator="['ReserveAdvanceDaysLimitNum', {rules: [{required: Boolean(isNeedReserve) && Boolean(ReserveAdvanceDaysLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                                </a-form-item>
                                <a-form-item label="单日限制预约次数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-radio-group @change="commonChange($event, 'DayReserveNumLimit', ['DayReserveNumLimitNum'])" :disabled="isDisable || !Boolean(isNeedReserve)" v-decorator="['DayReserveNumLimit', {initialValue: 1, rules: [{required: Boolean(isNeedReserve), message: '请选择'}]}]">
                                        <a-radio :value="1">限制预约次数</a-radio>
                                        <a-radio :value="0">不限制</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                                <a-form-item label="单日预约次数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-input-number :max="999999999" :disabled="isDisable || !Boolean(isNeedReserve) || !Boolean(DayReserveNumLimit)" style="width: 100%;" v-decorator="['DayReserveNumLimitNum', {rules: [{required: Boolean(isNeedReserve) && Boolean(DayReserveNumLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                                </a-form-item>
                                <a-form-item label="小程序是否可以取消预约" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-radio-group @change="commonChange($event, 'isCanCancelReserve', ['CancelReserveAdvanceDaysLimit', 'CancelReserveAdvanceDaysLimitNum'])" :disabled="isDisable" v-decorator="['isCanCancelReserve', {initialValue: 0, rules: [{required: Boolean(isNeedReserve), message: '请选择'}]}]">
                                        <a-radio :value="1">可以取消</a-radio>
                                        <a-radio :value="0">不可取消</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                                <a-form-item label="取消预约规则" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-radio-group @change="commonChange($event, 'CancelReserveAdvanceDaysLimit', ['CancelReserveAdvanceDaysLimitNum'])" :disabled="isDisable || !Boolean(isNeedReserve) || !Boolean(isCanCancelReserve)" v-decorator="['CancelReserveAdvanceDaysLimit', {initialValue: CancelReserveAdvanceDaysLimit, rules: [{required: Boolean(isNeedReserve) && Boolean(isCanCancelReserve), message: '请选择'}]}]">
                                        <a-radio :value="0">当天可取消</a-radio>
                                        <a-radio :value="1">提前取消</a-radio>
                                    </a-radio-group>
                                </a-form-item>
                                <a-form-item label="提前天数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                    <a-input-number :max="999999999" :disabled="isDisable || !Boolean(isNeedReserve) || !Boolean(isCanCancelReserve) || !Boolean(CancelReserveAdvanceDaysLimit)" style="width: 100%;" v-decorator="['CancelReserveAdvanceDaysLimitNum', {rules: [{required: Boolean(isNeedReserve) && Boolean(isCanCancelReserve) && Boolean(CancelReserveAdvanceDaysLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '必须是正整数'}]}]" placeholder="请输入"></a-input-number>
                                </a-form-item>
                            </div>
                        </a-card>
                    </div>
                    <!-- 使用信息 -->
                    <div class="add-ticket-block">
                        <a-card :bordered="false" title="使用信息">
                            <a-form-item label="人脸是否区分大人小孩" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" v-decorator="['isCheckFaceAge', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">区分</a-radio>
                                    <a-radio :value="0">不区分</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-row>
                                <a-col span="4" class="text-right">
                                    <a-form-item required label="可使用人数"></a-form-item>
                                </a-col>
                                <a-col span="10">
                                    <a-row>
                                        <a-col :span="11">
                                            <a-form-item>
                                                <a-input-number :max="999999999" :disabled="isDisable" class="input-group-left" v-decorator="['adultNum', {rules: [{required: true, message: '请输入大人数'}, {pattern: /^[0-9]*$/, message: '请输入正整数'}]}]" placeholder="请输入大人数" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="2">
                                            <a-form-item>
                                                <a-input class="input-group-center" placeholder="和" disabled />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="11">
                                            <a-form-item>
                                                <a-input-number :max="999999999" :disabled="isDisable" class="input-group-right" v-decorator="['babyNum', {rules: [{required: true, message: '请输入小孩数'}, {pattern: /^[0-9]*$/, message: '请输入正整数'}]}]" placeholder="请输入小孩数" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <a-form-item label="允许离场时间/分" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable" style="width: 100%;" v-decorator="['allowDepartureTime', {rules: [{required: true, message: '请输入'}, {pattern: /^([\d]*)$/, message: '请输入正整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                            </a-form-item>
                            <a-form-item label="是否可以转赠" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'giveTimesState', ['giveTimes'])" v-decorator="['giveTimesState', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">可以转赠</a-radio>
                                    <a-radio :value="0">不可转赠</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="可转赠次数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(giveTimesState)" style="width: 100%;" v-decorator="['giveTimes', {rules: [{required: Boolean(giveTimesState), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入正整数'}]}]" placeholder="请输入"></a-input-number>
                            </a-form-item>
                            <a-form-item label="是否可以持有者更改" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'ownerChangeState', ['ownerChangeLimit', 'ownerChangeTimes'])" v-decorator="['ownerChangeState', {initialValue: 1, rules: [{required: true, message: '请输入'}]}]">
                                    <a-radio :value="1">是</a-radio>
                                    <a-radio :value="0">否</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-row>
                                <a-col span="4" class="text-right">
                                    <a-form-item required label="可持有者更改次数"></a-form-item>
                                </a-col>
                                <a-col span="4" style="width:180px">
                                    <a-form-item :label-col="{span: 0}" :wrapper-col="{span: 24}">
                                        <a-radio-group :disabled="isDisable || !Boolean(ownerChangeState)" @change="commonChange($event, 'ownerChangeLimit', ['ownerChangeTimes'])" v-decorator="['ownerChangeLimit', {initialValue: 0, rules: [{required: Boolean(ownerChangeState), message: '请输入'}]}]">
                                            <a-radio :value="0">不限制次数</a-radio>
                                            <a-radio :value="1">限制</a-radio>
                                        </a-radio-group>
                                    </a-form-item>
                                </a-col>
                                <a-col span="6">
                                    <a-form-item label="" :label-col="{span: 0}" :wrapper-col="{span: 24}">
                                        <a-input-number :max="999999999" :disabled="isDisable || !Boolean(ownerChangeLimit) || !Boolean(ownerChangeState)" style="width: 100%;" v-decorator="['ownerChangeTimes', {rules: [{required: Boolean(ownerChangeLimit) && Boolean(ownerChangeState), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入正整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                                    </a-form-item>
                                </a-col>
                                <a-col span="1" class="ml16">
                                    <a-form-item label="次" :colon="false"></a-form-item>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col span="4" class="text-right">
                                    <a-form-item required label="核销时段"></a-form-item>
                                </a-col>
                                <a-col span="11" class="text-right">
                                    <a-form-item :label-col="{span: 0}" :wrapper-col="{span: 22}">
                                        <a-select :disabled="isDisable" style="width: 100%;" v-decorator="['suitTime', {rules: [{required: true, message: '请选择'}]}]">
                                            <a-select-option value="Currency">平日周末通用</a-select-option>
                                            <a-select-option value="WorkDay">平日可用</a-select-option>
                                            <a-select-option value="Weekend">周末可用</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <!-- <a-col span="4">
                                    <a v-if="!isDisable" @click="isCustomizeSuitTime = true" class="text-primary" style="line-height: 32px">添加自定义描述</a>
                                </a-col> -->
                            </a-row>
                            <a-row class="mb24">
                                <a-col span="13" offset="1">
                                    <a-alert type="info" show-icon message="「周末节假日通用选项，实际仅支持周末核销，节假日需前台人工判断强制核销」"></a-alert>
                                </a-col>
                                <!-- <a-col span="4">
                                    <a v-if="!isDisable" @click="isCustomizeSuitTime = true" class="text-primary" style="line-height: 32px">添加自定义描述</a>
                                </a-col> -->
                            </a-row>
                            <a-row v-show="isCustomizeSuitTime">
                                <a-col span="4" class="text-right">
                                    <a-form-item required label="自定义描述"></a-form-item>
                                </a-col>
                                <a-col span="11" class="text-right">
                                    <a-form-item :label-col="{span: 0}" :wrapper-col="{span: 23}">
                                        <a-input :disabled="isDisable" @input="customizeSuitTimeChange" v-decorator="['suitTimeDesc', {initialValue: '', rules: [{required: isCustomizeSuitTime, message: '请输入'}, {max: 6, message: '6字以内'}]}]" placeholder="请输入，（6字以内）" :suffix="suitTimeDesc.length + '/6'" />
                                    </a-form-item>
                                </a-col>
                                <a-col span="4">
                                    <a v-if="!isDisable" @click="delCustomizeSuitTime" class="text-primary" style="line-height: 32px">删除</a>
                                </a-col>
                            </a-row>
                            <a-row>
                                <a-col span="4" class="text-right">
                                    <a-form-item label="每日允许核销时间段"></a-form-item>
                                </a-col>
                                <a-col span="6">
                                    <a-row>
                                        <a-col :span="10">
                                            <a-form-item>
                                                <a-time-picker :disabled="isDisable" class="input-group-left" v-decorator="['AllowVerifyTimesLimit[0]', {rules: [{required: false, message: '请选择'}]}]" placeholder="时:分:秒" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="4">
                                            <a-form-item>
                                                <a-input class="input-group-center" placeholder="~" disabled />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="10">
                                            <a-form-item>
                                                <a-time-picker :disabled="isDisable" class="input-group-right" v-decorator="['AllowVerifyTimesLimit[1]', {rules: [{required: false, message: '请选择'}]}]" placeholder="时:分:秒" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                            <template v-for="(item, index) in noVerifyDateList">
                                <a-row :key="'excludeDate' + item.key">
                                    <a-col span="14">
                                        <a-form-item label="不允许核销日期区间" :label-col="{span: 7}" :wrapper-col="{span: 17}">
                                            <a-range-picker :disabled="isDisable" style="width: 100%;" v-decorator="[`NoVerifyDatesLimit[${index}]`, {initialValue: item.value}]" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="10">
                                        <a v-if="!isDisable && index == 0" @click="addNoverifyDate(index)" class="text-primary ml16" style="line-height: 32px;">增加</a>
                                        <a v-if="!isDisable && index > 0" @click="delNoverifyDate(index)" class="text-primary ml16" style="line-height: 32px;">删除</a>
                                    </a-col>
                                </a-row>
                            </template>
                            <a-form-item label="单日可核销次数限制" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'DayVerifyNumLimit', ['DayVerifyNumLimitNum'])" v-decorator="['DayVerifyNumLimit', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">限制核销次数</a-radio>
                                    <a-radio :value="0">不限制</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="单日可核销次数" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(DayVerifyNumLimit)" style="width: 100%;" v-decorator="['DayVerifyNumLimitNum', {rules: [{required: Boolean(DayVerifyNumLimit), message: '请输入'}, {pattern: /^([1-9]+)([0-9]*)$/, message: '请输入大于0的整数'}]}]" placeholder="请输入大于0的整数"></a-input-number>
                            </a-form-item>
                            <a-form-item label="宝宝信息认证" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <!-- <a-radio-group :disabled="isDisable || (form.getFieldValue('type') == 2 && form.getFieldValue('useNum') == 1)" v-decorator="['isBabyInfoAuth', {initialValue: form.getFieldValue('type') == 2 && form.getFieldValue('useNum') == 1 ? 0 : 1, rules: [{required: true, message: '请选择'}]}]"> -->
                                <a-radio-group :disabled="isDisable" v-decorator="['isBabyInfoAuth', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">需要认证</a-radio>
                                    <a-radio :value="0">无需认证</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-form-item label="适用年龄限制" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-radio-group :disabled="isDisable" @change="commonChange($event, 'BindBabyAgeLimit', ['BindBabyAgeLimitMin', 'BindBabyAgeLimitMax'])"  v-decorator="['BindBabyAgeLimit', {initialValue: 1, rules: [{required: true, message: '请选择'}]}]">
                                    <a-radio :value="1">有限制</a-radio>
                                    <a-radio :value="0">无限制</a-radio>
                                </a-radio-group>
                            </a-form-item>
                            <a-row>
                                <a-col span="4" class="text-right">
                                    <a-form-item required label="适用年龄段"></a-form-item>
                                </a-col>
                                <a-col span="10">
                                    <a-row>
                                        <a-col :span="11">
                                            <a-form-item>
                                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(BindBabyAgeLimit)" class="input-group-left" v-decorator="['BindBabyAgeLimitMin', {rules: [{required: Boolean(BindBabyAgeLimit), message: '请输入'}, {pattern: /^[0-9]*$/, message: '请输入正整数'}]}]" placeholder="请输入最小年龄" />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="2">
                                            <a-form-item>
                                                <a-input class="input-group-center" placeholder="~" disabled />
                                            </a-form-item>
                                        </a-col>
                                        <a-col :span="11">
                                            <a-form-item>
                                                <a-input-number :max="999999999" :disabled="isDisable || !Boolean(BindBabyAgeLimit)" class="input-group-right" v-decorator="['BindBabyAgeLimitMax', {rules: [{required: Boolean(BindBabyAgeLimit), message: '请输入'}, {pattern: /^[0-9]*$/, message: '请输入正整数'}]}]" placeholder="请输入最大年龄" />
                                            </a-form-item>
                                        </a-col>
                                    </a-row>
                                </a-col>
                            </a-row>
                        </a-card>
                    </div>
                    <!-- 图文描述 -->
                    <div class="add-ticket-block">
                        <a-card :bordered="false" title="图文描述">
                            <a-form-item label="票券封面图" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <image-uploader ref="uploader" :disabled="isDisable" :value="imgUrl" @uploaded="uploaded"></image-uploader>
                                <a-input type="hidden" v-decorator="['coverUrl', {rules: [{required: true, message: '请选择'}]}]" />
                            </a-form-item>
                            <a-form-item label="使用限制" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input :disabled="isDisable" v-decorator="['useExplain', {rules: [{required: false, message: '请输入'}, {max: 15, message: '15字以内'}]}]" placeholder="特权使用限制说明，例如：儿童需1.2米以下（15字以内）" />
                            </a-form-item>
                            <a-form-item label="分享时内容" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <a-input :disabled="isDisable" v-decorator="['shareContent', {rules: [{required: false, message: '请输入'}, {max: 36, message: '36字以内'}]}]" placeholder="请输入分享时内容（36字以内）" />
                            </a-form-item>
                            <a-form-item required label="票券介绍" :label-col="{span: 4}" :wrapper-col="{span: 10}">
                                <rich-text ref="rich" :list="contentList" v-if="!isDisable"></rich-text>
                                <rich-text-viewer :list="contentList" v-else></rich-text-viewer>
                            </a-form-item>
                        </a-card>
                    </div>
                </a-form>
            </a-spin>
            <!-- 适用门店选择 -->
            <a-modal
            centered
            title="选择门店"
            :width="800"
            :visible="selectShopVisible"
            :maskClosable="false"
            @ok="selectShopConfirm"
            @cancel="selectShopCancel"
            >

                <div class="font-weight font-big mb16 text-color-85">
                    <a-select allowClear v-model="currentCity" :options="cityList" placeholder="请选择" style="width: 300px;"></a-select>
                </div>
                <a-table
                style="word-break:break-all;"
                bordered
                :pagination="false"
                :scroll="{y: 400}"
                :columns="shopSelectColumns"
                :rowSelection="{type: 'radio', onChange: shopSelectChange, selectedRowKeys: shopSelectedRowKeys}"
                :dataSource="filtedShopList"
                :rowKey="item => item.id"
                >
                <template slot="address" scope="key, row">{{row.city + row.address}}</template>
                </a-table>
            </a-modal>
            <div class="btn-bar text-right">
                <a-alert style="display:inline-block" v-if="$route.name == 'updateTicket'" type="info" show-icon message="编辑后该票券内容将会刷新，但不会影响已售出票券。"></a-alert>
                <a-button class="ml8" :loading="submitLoading" @click="back">{{`${isDisable ? '返回' :'取消'}`}}</a-button>
                <a-button :loading="submitLoading" v-if="!isDisable" type="primary" @click="submit">确定</a-button>
            </div>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    import ImageUploader from '@/components/common/image-uploader.component';
    import richText from '@/components/modules/rich-text.component'
    import richTextViewer from '@/components/modules/rich-text-viewer.component'
    const columns = [
        {
            title: '门店名称',
            dataIndex: 'shopName',
            width: "33%"
        },
        {
            title: '库存选择',
            dataIndex: 'stockCategoryId',
            scopedSlots: {
                customRender: 'stockCategory'
            }
        },
        {
            title: '操作',
            dataIndex: 'shopId',
            scopedSlots: {
                customRender: 'actions'
            },
            width: "10%"
        }
    ];
    const shopSelectColumns = [
        {
            title: '门店名称',
            dataIndex: 'name',
            width: "35%"
        },
        {
            title: '门店地址',
            dataIndex: 'address',
            scopedSlots: {
                customRender: 'address'
            }
        }
    ];
    const ThirdSellData = [
        {value: 'meituan', label: '美团'},
        {value: 'douyin', label: '抖音'}
    ];
    const weekData = [
        {value: 1, label: '周一'},
        {value: 2, label: '周二'},
        {value: 3, label: '周三'},
        {value: 4, label: '周四'},
        {value: 5, label: '周五'},
        {value: 6, label: '周六'},
        {value: 7, label: '周日'}
    ];
    export default {
        name: "AddTicket",
        components: {
            ImageUploader,
            richText,
            richTextViewer
        },
        props: {},
        data() {
            return {
                columns,
                weekData,
                shopSelectColumns,
                useShopList: [],
                stockTypeState: 0,
                imgUrl: '',
                isDisable: false,
                isEdit: false,
                contentList: [],
                activeKey: 1,
                scrollLock: false,
                useNumDisabled: false,
                validTimeSetMode: 2,
                isCounterSell: 1,
                BuyNumLimit: 1,
                HoldNumLimit: 1,
                DayBuyNumLimit: 1,
                enableState: 1,
                disableState: 0,
                NoSellWeeksLimitIndeterminate: false,
                NoSellWeeksLimitCheckAll: false,
                excludeDateList: [],
                noVerifyDateList: [],
                isNeedReserve: 1,
                ReserveAdvanceDaysLimit: 1,
                isCanCancelReserve: 0,
                CancelReserveAdvanceDaysLimit: 1,
                giveTimesState: 1,
                ownerChangeState: 1,
                ownerChangeLimit: 0,
                BindBabyAgeLimit: 1,
                cityList: [],
                filtedShopList: [],
                shopList: [],
                selectShopVisible: false,
                shopSelectedRowKeys: [],
                currentCity: undefined,
                submitLoading: false,
                detailLoading: false,
                ticketTemplateId: null,
                DayReserveNumLimit: 1,
                DayVerifyNumLimit: 1,
                isNeedReserveDisabled: false,
                isCustomizeSuitTime: false,
                suitTimeDesc: '',
                counters: [],
                ThirdSellData,
                ThirdSellIndeterminate: false,
                ThirdSellCheckAll: false,
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            $route() {
                this.getTicketDetail();
                console.log(this.$route.query.ticketTemplateId);
            },
            currentCity(val, oval) {
                if (val) {
                    this.filtedShopList = this.shopList.filter(i => i.city === val);
                } else {
                    this.filtedShopList = this.shopList;
                }
            }
        },
        methods: {
            back() {
                this.$router.back();
            },
            /**
             * @customizeSuitTimeChange 适用时段自定义变化
             */ 
            customizeSuitTimeChange(e) {
                this.suitTimeDesc = e.target.value;
            },
            delCustomizeSuitTime() {
                this.isCustomizeSuitTime = false;
                this.form.resetFields(['suitTimeDesc']);
            },
            /**
             * @uploaded 封面图片选择
             */
            uploaded(val) {
                this.imgUrl = val;
                this.form.setFieldsValue({coverUrl: val});
            },
            /**
             * @changeTab tab点击回调
             */
            changeTab(val) {
                let targetValueMap = Array.prototype.map.call(this.targetEl, (i) => (i.offsetTop + 100));
                this.activeKey = val;
                this.scrollLock = true;
                this.scrollEl.scrollTop = targetValueMap[val - 1];
                setTimeout(() => {
                    this.scrollLock = false;
                }, 100);
            },
            /**
             * @scrollEvent 滚动回调
             */
            scrollEvent(e) {
                if (this.scrollLock) {
                    return false;
                }
                let currentValue = e.target.scrollTop;
                let targetValueMap = Array.prototype.map.call(this.targetEl, (i) => (i.offsetTop + 100));
                let activeKey = 1;
                targetValueMap.forEach((item, index) => {
                    if (currentValue > item) {
                        activeKey = index + 1;
                    }
                });
                this.activeKey = activeKey;
            },
            /**
             * @typeChange 票券类型变更回调
             */
            typeChange(e) {
                let val = e.target.value;
                if (val === 1) {
                    this.form.setFieldsValue({'useNum': -1});
                    this.useNumDisabled = true;
                } else {
                    this.form.resetFields('useNum');
                    this.useNumDisabled = false;
                }
            },
            /**
             * @validTimeSetModeChange 票券有效期类型变更回调
             */
            validTimeSetModeChange(e) {
                let val = e.target.value;
                this.validTimeSetMode = val;
                this.form.resetFields('validTimeSetParam');
            },
            /**
             * @isCounterSellChange 是否在门店收银台售卖变更回调
             */
            isCounterSellChange(e) {
                if(this.useShopList.length == 0) {
                    this.$message.error('请先选择适用门店')
                }else {
                    this.sellShopCounter(this.useShopList[0].shopId, this.useShopList[0].shopName);
                }
            },
            /**
             * @sellShopCounter 获取门店下所有票台
             */
            sellShopCounter(shopId,shopName) {
                this.$api.ticketDesk.cashPayPlatform({
                    body: {
                        shopId: shopId,
                        pageNum: 1,
                        pageSize: 999
                    }
                }).then(res => {
                    this.counters = [];
                    res.list.forEach(item => {
                        let countersItem = {
                            counterId: item.id,
                            counterName: item.name,
                            shopId: shopId,
                            shopName: shopName
                        };
                        this.counters.push(countersItem);
                    })
                });
            },
            /**
             * @commonChange 通用变更回调
             */
            commonChange(e, key, resetKeys) {
                let val = e.target.value;
                this[key] = val;
                this.form.resetFields(resetKeys);
                if (key === 'isNeedReserve') {
                    let stockCategoryIdKeys = {};
                    this.useShopList.forEach((i, index) => {
                        stockCategoryIdKeys[`stockCategoryId[${index}]`] = undefined;
                    });
                    this.form.setFieldsValue(stockCategoryIdKeys);
                    if (Boolean(val)) {
                        this.DayReserveNumLimit = 1;
                    }
                } else if (key === 'ownerChangeState') {
                    this.ownerChangeLimit = 0;
                } else if(key === 'isThirdSell') {
                    this.isNeedReserve = val === 0;
                }
            },
            /**
             * @datePickerChange 上下架日期变更回调
             */
            datePickerChange(e, key) {
                let val = e.target.value;
                this[key] = val;
                this.form.resetFields([key === 'enableState' ? 'onShelvesTime' : 'offShelvesTime']);
            },
            /**
             * @NoSellWeeksLimitAllChange 不可售卖日期全选回调
             */
            NoSellWeeksLimitAllChange(e) {
                let val = e.target.checked;
                if (val) {
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = true;
                    let NoSellWeeksLimit = this.weekData.map(i => i.value);
                    this.form.setFieldsValue({ NoSellWeeksLimit });
                } else {
                    this.form.setFieldsValue({ NoSellWeeksLimit: [] });
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = false;
                }
            },
            /**
             * @NoSellWeeksLimitChange 不可售卖日期选择回调
             */
            NoSellWeeksLimitChange(val) {
                if (val.length === 0) {
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = false;
                    return;
                }
                if (val.length < this.weekData.length) {
                    this.NoSellWeeksLimitIndeterminate = true;
                    this.NoSellWeeksLimitCheckAll = false;
                } else {
                    this.NoSellWeeksLimitIndeterminate = false;
                    this.NoSellWeeksLimitCheckAll = true;
                }
            },
            /**
             * @ThirdSellAllChange 第三方售卖全选回调
             */
            ThirdSellAllChange(e) {
                let val = e.target.checked;
                if (val) {
                    this.ThirdSellIndeterminate = false;
                    this.ThirdSellCheckAll = true;
                    let ThirdSell = this.ThirdSellData.map(i => i.value);
                    this.form.setFieldsValue({ ThirdSell });
                } else {
                    this.form.setFieldsValue({ ThirdSell: [] });
                    this.ThirdSellIndeterminate = false;
                    this.ThirdSellCheckAll = false;
                }
            },
            /**
             * @ThirdSellChange 第三方售卖选择回调
             */
            ThirdSellChange(val) {
                if (val.length === 0) {
                    this.ThirdSellIndeterminate = false;
                    this.ThirdSellCheckAll = false;
                    return;
                }
                if (val.length < this.ThirdSellData.length) {
                    this.ThirdSellIndeterminate = true;
                    this.ThirdSellCheckAll = false;
                } else {
                    this.ThirdSellIndeterminate = false;
                    this.ThirdSellCheckAll = true;
                }
            },
            /**
             * @addExcludeDate 增加排除日期范围
             */
            addExcludeDate(addExcludeDate, index) {
                let key = this.$moment().valueOf();
                this.excludeDateList.push({
                    key: addExcludeDate ? (key + index) : key,
                    value: addExcludeDate ? addExcludeDate : null
                });
            },
            /**
             * @addNoverifyDate 增加不允许核销日期范围
             */
            addNoverifyDate(addNoverifyDate, index) {
                let key = this.$moment().valueOf();
                this.noVerifyDateList.push({
                    key: addNoverifyDate ? (key + index) : key,
                    value: addNoverifyDate ? addNoverifyDate : null
                });
            },
            /**
             * @delExcludeDate 删除排除日期范围
             */
            delExcludeDate(index) {
                this.excludeDateList.splice(index, 1);
            },
            /**
             * @delNoverifyDate 删除不允许核销日期范围
             */
            delNoverifyDate(index) {
                this.noVerifyDateList.splice(index, 1);
            },
            /**
             * @getCityList 获取场地城市列表
             */
            getCityList() {
                this.$api.totalPlatform.cityList({}).then(res => {
                    this.cityList = res.map(item => {
                        return ({
                            label: item,
                            value: item
                        });
                    })
                });
            },
            /**
             * @getShopList 获取场地列表
             */
            getShopList() {
                return new Promise((resolve, reject) => {
                    this.$api.totalPlatform.selectList({}).then(res => {
                        res.forEach(i => {
                            i.label = i.name;
                            i.value = i.id;
                        });
                        this.filtedShopList = res;
                        this.shopList = res;
                        resolve();
                    });
                });
            },
            /**
             * @getStore 获取预约库存项目
             */
            getStore(shopId, index) {
                this.useShopList[index].spinning = true;
                this.$api.totalPlatform.getStore({
                    body: {
                        shopId,
                        stockCategory: 'TICKET'
                    }
                }).then(res => {
                    this.useShopList[index].spinning = false;
                    if (res && Array.isArray(res)) {
                        res.forEach(i => {
                            i.label = i.name;
                            i.value = i.id;
                        });
                    }
                    this.useShopList[index].options = res || [];
                });
            },
            /**
             * @shopSelectChange 场地选择
             */
            shopSelectChange(selectedRowKeys) {
                this.shopSelectedRowKeys = selectedRowKeys;
            },
            /**
             * @shopSelectAll 场地全选
             */
            shopSelectAll(val, selectedRows) {
                this.shopSelectedRowKeys = selectedRows.map(i => i.id);
            },
            /**
             * @selectShopCancel 场地选择确定取消
             */
            openSelectedShop() {
                this.shopSelectedRowKeys = this.useShopList.map(i => i.shopId);
                this.selectShopVisible = true;
            },
            /**
             * @selectShopConfirm 场地选择确定
             */
            selectShopConfirm() {
                this.useShopList = this.shopSelectedRowKeys.map(item => {
                    let selectedShop = this.shopList.find($item => $item.id === item);
                    let existItem = this.useShopList.find($item => $item.shopId === selectedShop.id);
                    if (Boolean(selectedShop)) {

                        this.sellShopCounter(selectedShop.id,selectedShop.name);
                        if (Boolean(existItem)) {
                            let { id, stockCategoryId, options } = existItem;
                            return ({
                                id,
                                shopId: selectedShop.id,
                                shopName: selectedShop.name,
                                stockCategoryId,
                                options,
                                spinning: false
                            })
                        } else {
                            return ({
                                id: null,
                                shopId: selectedShop.id,
                                shopName: selectedShop.name,
                                stockCategoryId: undefined,
                                options: [],
                                spinning: false
                            })
                        }
                    } else {
                        this.$message.error('所选门店数据没找到，请重试！');
                    }
                });
                this.useShopList.forEach((item, index) => {
                    if (item.options.length === 0) {
                        this.getStore(item.shopId, index);
                    }
                });
                this.selectShopCancel();
            },
            /**
             * @selectShopCancel 场地选择确定取消
             */
            selectShopCancel() {
                this.selectShopVisible = false;
                setTimeout(() => {
                    this.shopSelectedRowKeys = [];
                    this.currentCity = undefined;
                    this.filtedShopList = this.shopList;
                }, 300);
            },
            /**
             * @delUseShopItem 删除增加是否在门店收银台售卖选项
             */
            delUseShopItem(index) {
                let stockCategoryId = this.form.getFieldValue('stockCategoryId');
                stockCategoryId.forEach((item, index) => {
                    this.useShopList[index].stockCategoryId = item;
                });
                this.useShopList.splice(index, 1);
            },
            /**
             * @filterOption selected默认本地筛选
             */
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            /**
             * @submitDataFormat 提交数据序列化
             */
            submitDataFormat(values) {
                try {
                    // ticketSellCounterDTO 序列化
                    if (this.useShopList.length === 0) {
                        this.$message.error('适用门店不能为空！');
                        this.scrollLock = true;
                        this.scrollEl.scrollTop = this.$refs.useShopSet.offsetParent.offsetTop + 800;
                        setTimeout(() => {
                            this.scrollLock = false;
                        }, 100);
                        return false;
                    }
                    let ticketSellCounterDTO = {
                        ticketTemplateId: values.ticketTemplateId,
                        counters: values.isCounterSell == 1 ? this.counters : []
                    };

                    // configVos 序列化
                    let configVos = [];
                    if (Boolean(values.configVosShopId) && Array.isArray(values.configVosShopId)) {
                        values.configVosShopId.forEach((item, index) => {
                            let currentStockCategoryOptions = this.useShopList[index].options;
                            let currentStockCategoryItem = currentStockCategoryOptions.find($$item => $$item.id === values.stockCategoryId[index]);
                            let configVosItem = {
                                id: values.configVosIds[index],
                                reserveStockId: values.stockCategoryId[index],
                                reserveStockName: currentStockCategoryItem ? currentStockCategoryItem.label : null,
                                shopId: item,
                                shopName: this.useShopList[index].shopName,
                                ticketTemplateId: values.ticketTemplateId
                            }
                            configVos.push(configVosItem);
                        });
                    }
                    delete values.configVosIds;
                    delete values.configVosShopId;
                    delete values.stockCategoryId;
                    // ruleConfigDTOS 序列化
                    let ruleConfigDTOS = [];
                    //用户购买数量限制规则
                    if (Boolean(values.BuyNumLimit)) {
                        ruleConfigDTOS.push({
                            limitNum: values.BuyNumLimitNum,
                            ruleCode: 'BuyNumLimit'
                        });
                    }
                    delete values.BuyNumLimit;
                    delete values.BuyNumLimitNum;
                    //用户持有数量限制规则
                    if (Boolean(values.HoldNumLimit)) {
                        ruleConfigDTOS.push({
                            limitNum: values.HoldNumLimitNum,
                            ruleCode: 'HoldNumLimit'
                        });
                    }
                    delete values.HoldNumLimit;
                    delete values.HoldNumLimitNum;
                    //用户每日购买数量限制规则
                    if (Boolean(values.DayBuyNumLimit)) {
                        ruleConfigDTOS.push({
                            limitNum: values.DayBuyNumLimitNum,
                            ruleCode: 'DayBuyNumLimit'
                        });
                    }
                    delete values.DayBuyNumLimit;
                    delete values.DayBuyNumLimitNum;
                    //不可售卖星期限制规则
                    if (Boolean(values.NoSellWeeksLimit) && Boolean(values.NoSellWeeksLimit.length)) {
                        ruleConfigDTOS.push({
                            limitParams: values.NoSellWeeksLimit,
                            ruleCode: 'NoSellWeeksLimit'
                        });
                    }
                    delete values.NoSellWeeksLimit;
                    //不可售卖日期限制规则
                    if (Boolean(values.NoSellDatesLimit) && Boolean(values.NoSellDatesLimit.length)) {
                        let NoSellDatesLimit = values.NoSellDatesLimit.map(item => {
                            return (item[0].format('YYYY-MM-DD') + '~' + item[1].format('YYYY-MM-DD'));
                        });
                        ruleConfigDTOS.push({
                            limitParamSegments: NoSellDatesLimit,
                            ruleCode: 'NoSellDatesLimit'
                        });
                    }
                    delete values.NoSellDatesLimit;
                    //不允许核销日期区间规则
                    values.NoVerifyDatesLimit = values.NoVerifyDatesLimit.filter(item => item && item.length);
                    if (Boolean(values.NoVerifyDatesLimit) && Boolean(values.NoVerifyDatesLimit.length)) {
                        let NoVerifyDatesLimit = values.NoVerifyDatesLimit.map(item => {
                            return (item[0].format('YYYY-MM-DD') + '~' + item[1].format('YYYY-MM-DD'));
                        });
                        ruleConfigDTOS.push({
                            limitParamSegments: NoVerifyDatesLimit,
                            ruleCode: 'NoVerifyDatesLimit'
                        });
                    }
                    delete values.NoVerifyDatesLimit;
                    //提前预约限制规则
                    if (Boolean(values.ReserveAdvanceDaysLimit) && typeof values.ReserveAdvanceDaysLimitNum !== 'undefined') {
                        ruleConfigDTOS.push({
                            limitNum: values.ReserveAdvanceDaysLimitNum,
                            ruleCode: 'ReserveAdvanceDaysLimit'
                        });
                    }
                    delete values.ReserveAdvanceDaysLimit;
                    delete values.ReserveAdvanceDaysLimitNum;
                    //单日预约限制规则
                    if (Boolean(values.DayReserveNumLimit) && typeof values.DayReserveNumLimitNum !== 'undefined') {
                        ruleConfigDTOS.push({
                            limitNum: values.DayReserveNumLimitNum,
                            ruleCode: 'DayReserveNumLimit'
                        });
                    }
                    delete values.DayReserveNumLimit;
                    delete values.DayReserveNumLimitNum;
                    //提前取消预约限制规则
                    if (Boolean(values.CancelReserveAdvanceDaysLimit) && typeof values.CancelReserveAdvanceDaysLimitNum !== 'undefined') {
                        ruleConfigDTOS.push({
                            limitNum: values.CancelReserveAdvanceDaysLimitNum,
                            ruleCode: 'CancelReserveAdvanceDaysLimit'
                        });
                    }
                    delete values.CancelReserveAdvanceDaysLimit;
                    delete values.CancelReserveAdvanceDaysLimitNum;
                    //不可核销时间段限制规则
                    if (Boolean(values.AllowVerifyTimesLimit) && values.AllowVerifyTimesLimit[0] && values.AllowVerifyTimesLimit[1]) {
                        let AllowVerifyTimesLimit = values.AllowVerifyTimesLimit[0].format('HH:mm:ss') + '~' + values.AllowVerifyTimesLimit[1].format('HH:mm:ss');
                        ruleConfigDTOS.push({
                            limitParamSegments: [AllowVerifyTimesLimit],
                            ruleCode: 'AllowVerifyTimesLimit'
                        });
                    }
                    delete values.AllowVerifyTimesLimit;

                    //每日核销次数限制规则
                    if (Boolean(values.DayVerifyNumLimit)) {
                        ruleConfigDTOS.push({
                            limitNum: values.DayVerifyNumLimitNum,
                            ruleCode: 'DayVerifyNumLimit'
                        });
                    }
                    delete values.DayVerifyNumLimit;
                    delete values.DayVerifyNumLimitNum;
                    //绑定宝宝年龄段限制规则
                    if (Boolean(values.BindBabyAgeLimit)) {
                        ruleConfigDTOS.push({
                            limitParamSegment: values.BindBabyAgeLimitMin + '~' + values.BindBabyAgeLimitMax,
                            ruleCode: 'BindBabyAgeLimit'
                        });
                    }
                    delete values.BindBabyAgeLimit;
                    delete values.BindBabyAgeLimitMin;
                    delete values.BindBabyAgeLimitMax;
                    //有效期为固定时间的序列化
                    if (values.validTimeSetMode === 2) {
                        values.validTimeSetParam = values.validTimeSetParam.map((i, index) => {
                            if (index === 0) {
                                return i.format('YYYY-MM-DD 00:00:00');
                            } else {
                                return i.format('YYYY-MM-DD 23:59:59');
                            }
                        }).join('~');
                    }
                    // ticketSellThirdDTOS 第三方列表序列化
                    let ticketSellThirdDTOS = [];
                    values.isThirdSell == 1 && values.ThirdSell.forEach(e => {
                        if (e == "meituan") {
                            ticketSellThirdDTOS.push({
                                thirdCode: 'meituan',
                                thirdName: '美团',
                            })
                        }else if (e == "douyin") {
                            ticketSellThirdDTOS.push({
                                thirdCode: 'douyin',
                                thirdName: '抖音',
                            })
                        }
                    })
                    delete values.ThirdSell;
                    values.ticketSellThirdDTOS = ticketSellThirdDTOS;
                    // 上下架日期序列化
                    values.onShelvesTime = values.onShelvesTime ? values.onShelvesTime.format('YYYY-MM-DD HH:mm:ss') : null;
                    values.offShelvesTime = values.offShelvesTime ? values.offShelvesTime.format('YYYY-MM-DD HH:mm:ss') : null;
                    values.ruleConfigDTOS = ruleConfigDTOS;
                    values.shopId = this.shopId;
                    values.contentList = this.$refs.rich.getData().map(i => JSON.stringify(i));
                    if (!Boolean(values.giveTimesState)) {
                        values.giveTimes = 0;
                    }
                    if (!Boolean(values.ownerChangeState)) {
                        values.ownerChangeTimes = 0;
                    } else {
                        if (!Boolean(values.ownerChangeLimit)) {
                            values.ownerChangeTimes = -1;
                        }
                    }
                    let formatedData = {
                        configVos,
                        ticketSellCounterDTO,
                        ticketTemplateModifyDTO: values
                    }
                    if (!this.isEdit) {
                        formatedData.stockNum = Boolean(values.stockTypeState) ? values.stockNum : 999999999;
                    }
                    // 删除状态参数
                    delete values.enableState;
                    delete values.disableState;
                    delete values.giveTimesState;
                    delete values.ownerChangeState;
                    delete values.ownerChangeLimit;
                    delete values.stockTypeState;
                    delete values.stockNum;
                    return formatedData;
                } catch (error) {
                    console.error(error);
                    this.$message.error('数据序列化失败,请联系管理员！');
                    return false;
                }
            },

            /**
             * @submit 提交
             */
            submit() {
                if (this.submitLoading) {
                    return false;
                }
                this.submitLoading = true;
                this.form.validateFieldsAndScroll({force: true}, (errors, values) => {
                    if (errors) {
                        this.submitLoading = false;
                        return false;
                    }
                    let submitData = this.submitDataFormat(values);
                    if (!submitData) {
                        this.submitLoading = false;
                        return false;
                    }
                    if (submitData.ticketTemplateModifyDTO.contentList.length === 0) {
                        this.submitLoading = false;
                        this.$message.error('票券介绍不能为空！');
                        return false;
                    }
                    this.$api.totalPlatform[this.isEdit ? 'updateTicket' : 'createTicket']({
                        body: submitData
                    }).then(res => {
                        this.submitLoading = false;
                        this.$message.success('操作成功！');
                        this.back();
                    }).catch(err => {
                        this.submitLoading = false;
                    });
                });
            },
            /**
             * @getTicketDetail 获取票券详情
             */
            getTicketDetail() {
                this.detailLoading = true;
                this.$api.totalPlatform.ticketDetail({
                    params: {
                        ticketTemplateId: this.$route.query.ticketTemplateId
                    }
                }).then(res => {
                    this.isNeedReserveDisabled = this.$route.query.isCopy ? false : Boolean(res.totalSellNum) || Boolean(res.lockNum) || Boolean(res.prepareReduceNum);
                    this.reverseDataForReWrite(res);
                    this.detailLoading = false;
                }).catch(err => {

                });
            },
            /**
             * @reverseDataForReWrite 数据反序列化回填
             */
            reverseDataForReWrite(res) {
                try {
                    this.ticketTemplateId = res.ticketTemplateId;
                    this.isCustomizeSuitTime = Boolean(res.suitTimeDesc);
                    this.suitTimeDesc = res.suitTimeDesc || "";
                    //通用回填
                    this.form.setFieldsValue({
                        ticketTemplateId: res.ticketTemplateId,
                        showName: res.showName,
                        name: res.name,
                        stockNum: res.totalStockNum !== 999999999 ? res.totalStockNum : undefined,
                        stockTypeState: res.totalStockNum === 999999999 ? 0 : 1,
                        type: res.type,
                        useNum: res.useNum,
                        validTimeSetMode: res.validTimeSetMode,
                        sellShowPrice: res.sellShowPrice,
                        originalPrice: res.originalPrice,
                        suitScopeShow: res.suitScopeShow,
                        isShowOriginal: Number(res.isShowOriginal),
                        isMyTicketShow: Number(res.isMyTicketShow),
                        isCounterSell: Number(res.isCounterSell),
                        isRefundAble: Number(res.isRefundAble),
                        refundExplain: res.refundExplain,
                        isMiniSell: Number(res.isMiniSell),
                        isPointSell: Number(res.isPointSell),
                        isThirdSell: Number(res.isThirdSell),
                        isAppSellPlaceTop: Number(res.isAppSellPlaceTop),
                        onShelvesTime: res.onShelvesTime ? this.$moment(res.onShelvesTime) : undefined,
                        offShelvesTime: res.offShelvesTime ? this.$moment(res.offShelvesTime) : undefined,
                        isNeedReserve: Number(res.isNeedReserve),
                        isCanCancelReserve: Number(res.isCanCancelReserve),
                        adultNum: res.adultNum,
                        babyNum: res.babyNum,
                        allowDepartureTime: res.allowDepartureTime,
                        suitTime: res.suitTime,
                        suitTimeDesc: res.suitTimeDesc,
                        isBabyInfoAuth: Number(res.isBabyInfoAuth),
                        reverseDataForReWrite: Number(res.reverseDataForReWrite),
                        useExplain: res.useExplain,
                        shareContent: res.shareContent,
                        coverUrl: res.coverUrl,
                        giveTimes: res.giveTimes || undefined,
                        isCheckFaceAge: res.isCheckFaceAge ? 1 : 0,
                        giveTimesState: res.giveTimes ? 1 : 0,
                        ownerChangeTimes: (res.ownerChangeTimes == -1 || !res.ownerChangeTimes) ? undefined : res.ownerChangeTimes,
                        ownerChangeState: res.ownerChangeTimes ? 1 : 0,
                        ownerChangeLimit: res.ownerChangeTimes && res.ownerChangeTimes !== -1 ? 1 : 0,
                    });
                    //票券有效期分类型序列化回填
                    setTimeout(() => {
                        let validTimeSetParam = null;
                        if (res.validTimeSetMode === 2) {
                            validTimeSetParam = res.validTimeSetParam.split('~').map(i => this.$moment(i));
                        } else {
                            validTimeSetParam = Number(res.validTimeSetParam);
                        }
                        this.form.setFieldsValue({
                            validTimeSetParam
                        });
                    }, 300);
                    //ruleConfigDTOS反序列化回填
                    let {
                        BindBabyAgeLimit,
                        BuyNumLimit,
                        CancelReserveAdvanceDaysLimit,
                        DayBuyNumLimit,
                        DayReserveNumLimit,
                        DayVerifyNumLimit,
                        HoldNumLimit,
                        NoSellDatesLimit,
                        NoVerifyDatesLimit,
                        NoSellWeeksLimit,
                        AllowVerifyTimesLimit,
                        ReserveAdvanceDaysLimit,
                    } = res.ruleConfigVos || {};
                    let obj = {
                        BindBabyAgeLimit: Boolean(BindBabyAgeLimit) ? 1 : 0,
                        BindBabyAgeLimitMin: Boolean(BindBabyAgeLimit) ? Number(BindBabyAgeLimit.ruleParam.split('~')[0]) : undefined,
                        BindBabyAgeLimitMax: Boolean(BindBabyAgeLimit) ? Number(BindBabyAgeLimit.ruleParam.split('~')[1]) : undefined,
                        BuyNumLimit: Boolean(BuyNumLimit) ? 1 : 0,
                        BuyNumLimitNum: Boolean(BuyNumLimit) ? Number(BuyNumLimit.ruleParam) : undefined,
                        CancelReserveAdvanceDaysLimit: Boolean(CancelReserveAdvanceDaysLimit) ? 1 : 0,
                        CancelReserveAdvanceDaysLimitNum: Boolean(CancelReserveAdvanceDaysLimit) ? Number(CancelReserveAdvanceDaysLimit.ruleParam) : undefined,
                        DayBuyNumLimit: Boolean(DayBuyNumLimit) ? 1 : 0,
                        DayBuyNumLimitNum: Boolean(DayBuyNumLimit) ? Number(DayBuyNumLimit.ruleParam) : undefined,
                        DayReserveNumLimit: Boolean(DayReserveNumLimit) ? 1 : 0,
                        DayReserveNumLimitNum: Boolean(DayReserveNumLimit) ? Number(DayReserveNumLimit.ruleParam) : undefined,
                        DayVerifyNumLimit: Boolean(DayVerifyNumLimit) ? 1 : 0,
                        DayVerifyNumLimitNum: Boolean(DayVerifyNumLimit) ? Number(DayVerifyNumLimit.ruleParam) : undefined,
                        HoldNumLimit: Boolean(HoldNumLimit) ? 1 : 0,
                        HoldNumLimitNum: Boolean(HoldNumLimit) ? Number(HoldNumLimit.ruleParam) : undefined,
                        NoSellWeeksLimit: Boolean(NoSellWeeksLimit) ? JSON.parse(NoSellWeeksLimit.ruleParam).map(Number) : undefined,
                        'AllowVerifyTimesLimit[0]': Boolean(AllowVerifyTimesLimit) ? this.$moment(this.$moment().format('YYYY-MM-DD') + ' ' + JSON.parse(AllowVerifyTimesLimit.ruleParam)[0].split('~')[0]) : undefined,
                        'AllowVerifyTimesLimit[1]': Boolean(AllowVerifyTimesLimit) ? this.$moment(this.$moment().format('YYYY-MM-DD') + ' ' + JSON.parse(AllowVerifyTimesLimit.ruleParam)[0].split('~')[1]) : undefined,
                        ReserveAdvanceDaysLimit: Boolean(ReserveAdvanceDaysLimit) ? 1 : 0,
                        ReserveAdvanceDaysLimitNum: Boolean(ReserveAdvanceDaysLimit) ? Number(ReserveAdvanceDaysLimit.ruleParam) : undefined,
                    }
                    obj.ThirdSell = [];
                    res.isThirdSell && res.ticketSellThirdVos.forEach(e => {
                        obj.ThirdSell.push(e.thirdCode)
                    })
                    if (Boolean(NoSellDatesLimit)) {
                        let NoSellDatesLimitList = JSON.parse(NoSellDatesLimit.ruleParam);
                        NoSellDatesLimitList.forEach((item, index) => {
                            let dates = item.split('~').map(i => this.$moment(i));
                            this.addExcludeDate(dates, index + 1);
                        });
                    }
                    if (Boolean(NoVerifyDatesLimit)) {
                        let NoVerifyDatesLimitList = JSON.parse(NoVerifyDatesLimit.ruleParam);
                        NoVerifyDatesLimitList.forEach((item, index) => {
                            let dates = item.split('~').map(i => this.$moment(i));
                            this.addNoverifyDate(dates, index + 1);
                        });
                    }else {
                        this.addNoverifyDate()
                    }
                    this.stockTypeState = res.totalStockNum === 999999999 ? 0 : 1;
                    this.validTimeSetMode = res.validTimeSetMode;
                    this.enableState = res.onShelvesTime ? 1 : 0;
                    this.disableState = res.offShelvesTime ? 1 : 0;
                    this.contentList = res.contentList.map(i => JSON.parse(i));
                    this.imgUrl = res.coverUrl;
                    this.useNumDisabled = res.useNum === -1 ? true : false;
                    this.isNeedReserve = Number(res.isNeedReserve);
                    this.isCanCancelReserve = Number(res.isCanCancelReserve);
                    this.NoSellWeeksLimitIndeterminate = NoSellWeeksLimit ? JSON.parse(NoSellWeeksLimit.ruleParam).length < this.weekData.length : false;
                    this.NoSellWeeksLimitCheckAll = NoSellWeeksLimit ? JSON.parse(NoSellWeeksLimit.ruleParam).length === this.weekData.length : false;
                    this.BindBabyAgeLimit = Boolean(BindBabyAgeLimit) ? 1 : 0;
                    this.BuyNumLimit = Boolean(BuyNumLimit) ? 1 : 0;
                    this.CancelReserveAdvanceDaysLimit = Boolean(CancelReserveAdvanceDaysLimit) ? 1 : 0;
                    this.DayBuyNumLimit = Boolean(DayBuyNumLimit) ? 1 : 0;
                    this.HoldNumLimit = Boolean(HoldNumLimit) ? 1 : 0;
                    this.ReserveAdvanceDaysLimit = Boolean(ReserveAdvanceDaysLimit) ? 1 : 0;
                    this.DayReserveNumLimit = Boolean(DayReserveNumLimit) ? 1 : 0;
                    this.DayVerifyNumLimit = Boolean(DayVerifyNumLimit) ? 1 : 0;
                    this.giveTimesState = Boolean(res.giveTimes);
                    this.ownerChangeState = Boolean(res.ownerChangeTimes);
                    this.ownerChangeLimit = Boolean(res.ownerChangeTimes && res.ownerChangeTimes !== -1);
                    //售卖收银台回填
                    if (Array.isArray(res.suitShopReserveStockConfigs) && res.suitShopReserveStockConfigs.length > 0) {
                        res.suitShopReserveStockConfigs.forEach((item, index) => {
                            this.sellShopCounter(item.shopId, item.shopName);
                        });
                    }
                    //适用门店回填
                    if (res.suitShopReserveStockConfigs && Array.isArray(res.suitShopReserveStockConfigs)) {
                        let useShopList = [];
                        res.suitShopReserveStockConfigs.forEach((item, index) => {
                            let selectedShop = this.shopList.find($item => $item.id === item.shopId);
                            selectedShop && useShopList.push({
                                id: item.id,
                                shopId: item.shopId,
                                shopName: item.shopName,
                                stockCategoryId: item.reserveStockId,
                                options: [],
                                spinning: false
                            });
                        });
                        this.useShopList = useShopList;
                        this.useShopList.forEach((item, index) => {
                            this.getStore(item.shopId, index);
                        });
                    }

                    this.form.setFieldsValue(obj);
                } catch (error) {
                    console.error(error)
                }
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.scrollEl = document.getElementsByClassName('main-container-cover')[0];
            this.targetEl = document.getElementsByClassName('add-ticket-block');
            this.scrollEl.addEventListener('scroll', this.scrollEvent);
            this.getCityList();
            this.getShopList().then(() => {
                if (this.$route.name === 'detailTicket' || this.$route.name === 'counterTicketDetail' || this.$route.name === 'categoryTicketDetail') {
                    this.getTicketDetail();
                    this.isDisable = true;
                } else if (this.$route.name === 'updateTicket') {
                    this.getTicketDetail();
                    this.isEdit = true;
                }else {
                    if(this.$route.query.isCopy) {
                        this.getTicketDetail();
                    }else {
                        this.addNoverifyDate();
                    }
                }
                this.isNeedReserve = this.form.getFieldValue('isThirdSell') === 0;
            });
        },
        beforeDestroy() {
            this.scrollEl.removeEventListener('scroll', this.scrollEvent);
        },
    };
</script>
<style lang="scss">
    .add-ticket {
        &-tab {
            background: #ffffff;
            overflow: hidden;
            margin-bottom: 20px;
            position: sticky;
            top: 0px;
            z-index: 9;
            box-shadow: 0 0 7px #cccccc;
            .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
                height: 60px;
            }

            .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
                background: #fff;
                transition: none;
            }

            .ant-tabs-card > .ant-tabs-bar {
                border-color: #fff;
                margin-bottom: 0;
                transition: none;
            }

            .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
                height: 60px;
                border-color: transparent;
                background: transparent;
                transition: none;
                padding-top:8px;

            }
            .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
                border: 0;
                border-top: 3px solid #ff6d33;
                border-radius: 0;
                background: #f8f8f8;
                transition: none;
            }
        }
        &-block {
            background: #ffffff;
            box-shadow: 0 0 7px #cccccc;
            border-radius: 2px;
            margin-bottom: 20px;
        }
        .shop-selled-block {
            border: 1px solid #dddddd;
            padding: 24px 10px 0 10px;
            margin-bottom: 24px;
            background: #f8f8f8;
        }
        .input-group-left {
            width: 100%;
            text-align: center;
            border-right: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            input {
                text-align: center;
                border-right: 0;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }
        .input-group-center {
            width: 100%;
            text-align: center;
            border-left: 0;
            border-right: 0;
            border-radius: 0;
            pointer-events: none;
            background: #ffffff;
            input {
                text-align: center;
                border-left: 0;
                border-right: 0;
                border-radius: 0;
                pointer-events: none;
                background: #ffffff;
            }
        }
        .input-group-right {
            width: 100%;
            text-align: center;
            border-left: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            input {
                text-align: center;
                border-left: 0;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
        .btn-bar {
            padding: 14px 24px;
            background: #ffffff;
            border-top: 1px solid #dddddd;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 9;
        }
    }
</style>